import {
	CustomEmojiData,
	RawEventRSVPOption,
	GuildData,
	OptionPreset,
} from "./sesh_types";
import { Constants } from "./constants";
import { cloneDeep } from "lodash";

export namespace common_format_utils {
	export function get_stringified_emoji_for_embed(
		emoji: Pick<CustomEmojiData, "id" | "name" | "animated">
	) {
		const a = emoji.animated ? "a" : "";
		return `<${a}:${emoji.name}:${emoji.id}>`;
	}

	export function get_stringified_emoji_for_reaction(emoji: CustomEmojiData) {
		const a = emoji.animated ? "a:" : "";
		return `${a}${emoji.name}:${emoji.id}`;
	}

	export function get_unused_not_found_emoji(options: RawEventRSVPOption[]) {
		const potential_not_found_emojis: CustomEmojiData[] = cloneDeep(
			Constants.SESH_CUSTOM_EMOJIS.NOT_FOUND
		);
		for (const option of options) {
			let i = 0;
			for (const not_found_emoji of potential_not_found_emojis) {
				if (option.emoji === not_found_emoji.id) {
					potential_not_found_emojis.splice(i, 1);
					break;
				}
				i++;
			}
		}

		if (potential_not_found_emojis.length > 0) {
			return potential_not_found_emojis[0];
		}
	}

	export function get_guild_icon_url(guild_data: GuildData) {
		if (!guild_data.icon) {
			return;
		}
		return `https://cdn.discordapp.com/icons/${guild_data.id}/${guild_data.icon}.png`;
	}

	export function get_duplicate_emojis_in_preset(preset: OptionPreset) {
		for (const option of preset.custom_options) {
			const filter_result = preset.custom_options.filter(
				(value) => value.emoji === option.emoji
			);

			if (filter_result.length > 1) {
				return option.emoji;
			}
		}
		return null;
	}
}
